import './NewFooter.css';
import mainLogo from '../assets/final_img-Photoroom.png';
const NewFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon"><img src={mainLogo} width={40} height={40} alt="RoomBuddy Logo" className="logo" /></span>
              <span className="logo-text">Room<span className="logo-accent">Buddy</span></span>
            </div>
            <p className="footer-tagline">
              Hyderabad's most trusted To-Let service. Verified homes, free moving support, and stress-free shifting.
            </p>
          </div>
          <div className="footer-links-group">
            <h4 className="footer-heading">Quick Links</h4>
            <a href="#home">Home</a>
            <a href="#features">Services</a>
            <a href="#about">About Us</a>
            <a href="#contact">Contact</a>
             <a href="/privacy">Privacy Policy</a>
              <a href="/termsConditions">Terms & Conditions</a>
          </div>
          <div className="footer-links-group">
            <h4 className="footer-heading">Contact</h4>
            <a href="tel:+917989237393">📞 +91-7989237393</a>
            <a href="mailto:support@roombuddy.in">✉️ support@roombuddy.in</a>
            <span>📍 Madhapur, Hitech City, Hyderabad</span>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} RoomBuddy To-Let Service. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
export default NewFooter;
